module.exports = __webpack_public_path__ + "static/assets/efab989282e221f57ac7e9af9979b647.png";